var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.717,
    height: 110.692,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3190.843 -1282.728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3215.642 1337.908h9.475l8.4-7.121 16.9.1 8.407-19.786h16.928l10.784-16.942",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3223.152 1362.258h-12.7a2.116 2.116 0 00-2.116 2.116v28.549h16.928v-28.549a2.115 2.115 0 00-2.112-2.116zM3273.783 1341.677h-12.7a2.116 2.116 0 00-2.116 2.116v49.13h16.933v-49.13a2.116 2.116 0 00-2.117-2.116z",
    fill: "#b3cde3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3299.1 1326.773h-12.7a2.116 2.116 0 00-2.116 2.116v64.034h16.928v-64.034a2.116 2.116 0 00-2.112-2.116zM3248.468 1353.25h-12.7a2.116 2.116 0 00-2.116 2.116v37.557h16.928v-37.557a2.116 2.116 0 00-2.112-2.116z",
    fill: "#6d8dc1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.464,
    cy: 8.464,
    r: 8.464,
    transform: "translate(3208.189 1329.444)",
    fill: "#db0001"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.464,
    cy: 8.464,
    r: 8.464,
    transform: "translate(3233.505 1321.851)",
    fill: "#db0001"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.464,
    cy: 8.464,
    r: 8.464,
    transform: "translate(3258.821 1302.64)",
    fill: "#369528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3286.533 1294.161l-.7 4.1a1.837 1.837 0 002.666 1.938l3.688-1.94 3.687 1.94a1.839 1.839 0 002.693-1.627 1.928 1.928 0 00-.026-.311l-.7-4.1 2.986-2.907a1.837 1.837 0 00-1.018-3.134l-4.127-.6-1.838-3.734a1.913 1.913 0 00-3.3 0l-1.837 3.734-4.123.6a1.836 1.836 0 00-1.018 3.134z",
    strokeMiterlimit: 10,
    fill: "#f9fb7a",
    stroke: "#f9fb7a",
    strokeWidth: 0.221
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.857,
    d: "M3190.843 1392.991h124.717"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout03);
export default __webpack_public_path__ + "static/media/about-03.934acaff.svg";
export { ForwardRef as ReactComponent };